import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    details: {},
    error: false
};

export const fetchConfirmationDetailsDone = (state = INITIAL_STATE, { details }) => {
    return { ...state, details, error: false};
};

export const fetchConfirmationDetailsFailed = (state = INITIAL_STATE) => {
    return { ...state, details: {}, error: true};
};

export const HANDLERS = {
    [Types.FETCH_APPOINTMENT_DETAILS_SUCCESS]: fetchConfirmationDetailsDone,
    [Types.FETCH_APPOINTMENT_DETAILS_FAILURE]: fetchConfirmationDetailsFailed
};

export default createReducer(INITIAL_STATE, HANDLERS);
